module.exports = __webpack_public_path__ + "img/kr-product-final-card1-img3.a4057a9.png";